export const DEFAULT_MIN_SEARCH_TERM_LENGTH = 3;
export const DEFAULT_DEBOUNCE_TIME = 350;
export const DEFAULT_WARNING_MESSAGES = {
  minLength: "Please enter at least 3 characters",
  notFound: "No results found"
};
export const DEFAULT_TOP_POSITION_OFFSET = 40;
